import { 
  Box, 
  Typography, 
} from '@mui/material';

const CloudPortalHeader = () => {
  return (
    <Box display="flex" justifyContent="space-between" alignItems="center" mb={4}>
      <Box>
       
        <Typography color="text.secondary">
          Monitor and Manage your virtual machines
        </Typography>
      </Box>
     </Box>
  );
};

export default CloudPortalHeader;
